import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ page = {}, title = page.title }) => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          baseUrl
        }
      }
    }
  `);

  const defaults = {
    ...data.site.siteMetadata,
    baseUrl:
      data.site.siteMetadata.baseUrl ||
      process.env.DEPLOY_PRIME_URL ||
      (typeof window !== undefined && window.location?.origin),
  };

  if (defaults.baseUrl === '') {
    // console.error('Please set a baseUrl in your site metadata!');
    return null;
  }

  const description = page.description || defaults.description;
  const url = new URL(page.path || '', defaults.baseUrl).href;
  const image = page.image ? new URL(page.image, defaults.baseUrl).href : false;

  return (
    <Helmet>
      <title>{title || defaults.title}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content={description} />
      {image && <meta name="image" content={image} />}

      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title || defaults.title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaults.title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default SEO;
